import { GridColDef } from "@mui/x-data-grid";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Chip, Switch, Tooltip } from "@mui/material";
import ActionButton from "../client-config/action-button";
import { FILTER_DEFAULT_VISIBILITY_LABELS } from "./enum-labels";
import { ClientVisibilityRow } from "./client-visibility-types";

export const getColumns = ({
  onToggleEnabled,
  onReset,
}: {
  onToggleEnabled: (row: ClientVisibilityRow) => void;
  onReset: (row: ClientVisibilityRow) => void;
}): GridColDef[] => [
  { field: "code", headerName: "Code", flex: 1 },
  { field: "label", headerName: "Label", flex: 1 },
  {
    field: "defaultVisibility",
    headerName: "Default Visibility",
    flex: 1,
    valueGetter: (value: keyof typeof FILTER_DEFAULT_VISIBILITY_LABELS) =>
      FILTER_DEFAULT_VISIBILITY_LABELS[value] ?? value,
  },
  {
    field: "isOverridden",
    headerName: "Overridden",
    maxWidth: 130,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      params.row.isOverridden ? (
        <Chip label="Overridden" size="small" color="warning" />
      ) : null,
  },
  {
    field: "isEnabled",
    headerName: "Enabled",
    maxWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Tooltip
        title={params.row.isEnabled ? "Click to disable" : "Click to enable"}
        placement="top"
      >
        <Switch
          checked={params.row.isEnabled}
          onChange={(e) => {
            e.stopPropagation();
            onToggleEnabled(params.row);
          }}
          onClick={(e) => e.stopPropagation()}
          color="success"
          size="small"
        />
      </Tooltip>
    ),
  },
  {
    field: "actions",
    type: "actions",
    flex: 1,
    align: "right",
    maxWidth: 130,
    getActions: ({ row }: { row: ClientVisibilityRow }) =>
      row.isOverridden
        ? [
            <Tooltip key="reset" title="Reset to default">
              <ActionButton
                onClick={(e) => {
                  e.stopPropagation();
                  onReset(row);
                }}
              >
                <RestartAltIcon fontSize="small" />
              </ActionButton>
            </Tooltip>,
          ]
        : [],
  },
];

export default getColumns;
